import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAppDispatch } from '@/store/hooks';
import { createBlog } from '../store/blogSlice';
import { toast } from 'sonner';

interface CreateBlogModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CreateBlogModal = ({ open, onOpenChange }: CreateBlogModalProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!title.trim()) {
      toast.error('Vui lòng nhập tên blog');
      return;
    }

    setLoading(true);
    try {
      const result = await dispatch(createBlog({ title: title.trim() })).unwrap();
      toast.success('Tạo blog thành công!');
      onOpenChange(false);
      setTitle('');
      // Navigate to the blog page
      navigate(`/blogs/${result.slug}`);
    } catch (error: any) {
      toast.error(error?.message || 'Không thể tạo blog');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Tạo Blog Mới</DialogTitle>
            <DialogDescription>
              Nhập tên cho blog của bạn. Bạn có thể chỉnh sửa sau.
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid gap-2">
              <Label htmlFor="title">Tên Blog</Label>
              <Input
                id="title"
                placeholder="Ví dụ: Blog Công Nghệ"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                disabled={loading}
                autoFocus
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={loading}
            >
              Hủy
            </Button>
            <Button type="submit" disabled={loading || !title.trim()}>
              {loading ? 'Đang tạo...' : 'Tạo Blog'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
